import React from "react";
import HubSpotForm from "./HubSpotForm";

/**
 * Backwards-compatible drop-in: the original PropertyApplicationForm was a
 * custom multi-section form. The current site funnels every lead through the
 * unified HubSpot embed instead, so this component renders the HubSpot form
 * inside the same lux-card wrapper to keep page layouts intact.
 */
export default function PropertyApplicationForm() {
  return (
    <div className="lux-card" data-testid="property-app-form">
      <div className="overline">Step 2 — Application</div>
      <h3 className="font-display text-4xl text-[var(--emerald)] mt-3">
        Tell us about your property.
      </h3>
      <p className="text-sm text-[var(--ink-2)] mt-3 max-w-2xl">
        Share the essentials and a Property's Concierge will reach out within a week to review
        the next steps.
      </p>
      <div className="mt-6">
        <HubSpotForm context="property-application" />
      </div>
    </div>
  );
}
